import { Star, Quote } from "lucide-react";
import { reviews, brand } from "../mock";

export default function Reviews() {
  return (
    <section id="recensioni" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="text-[#e2001a] font-semibold text-sm uppercase tracking-wide">Dicono di noi</span>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-[#16181d] mt-2">
              I nostri clienti ci consigliano
            </h2>
          </div>
          <div className="flex items-center gap-4 bg-[#f5f6f8] rounded-2xl px-6 py-4">
            <p className="font-display font-extrabold text-4xl text-[#16181d]">
              {brand.rating.toString().replace(".", ",")}
            </p>
            <div>
              <div className="flex">
                {[1, 2, 3, 4, 5].map((i) => (
                  <Star key={i} className={`w-4 h-4 ${i <= Math.round(brand.rating) ? "fill-yellow-400 text-yellow-400" : "text-gray-300"}`} />
                ))}
              </div>
              <p className="text-sm text-gray-500 mt-1">{brand.reviewsCount} recensioni Google</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((r) => (
            <div key={r.name} className="relative rounded-2xl border border-gray-100 p-6 card-hover bg-white">
              <Quote className="w-9 h-9 text-[#e2001a]/15 absolute top-5 right-5" />
              <div className="flex mb-3">
                {Array.from({ length: r.stars }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <p className="text-[#16181d] leading-relaxed">“{r.text}”</p>
              <div className="mt-5 flex items-center gap-3">
                <span className="w-10 h-10 rounded-full bg-[#e2001a] text-white flex items-center justify-center font-display font-bold">
                  {r.name.charAt(0)}
                </span>
                <div>
                  <p className="font-semibold text-[#16181d] text-sm">{r.name}</p>
                  <p className="text-xs text-gray-400">Recensione verificata Google</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
